export const deviceResourcesTypes = [
    'BlackToner',
    'BlackToner1',
    'CyanToner',
    'MagentaToner',
    'YellowToner',
    'BlackDrum',
    'CyanDrum',
    'MagentaDrum',
    'YellowDrum',
    'Drum',
    'Developer',
    'ImagingUnit',
    'TransferRoller',
    'Belt',
    'Fuser',
    'MaintenanceKit',
    'OzoneFilter',
    'Wastetank'
]